import dayjs from 'dayjs';
import { create } from 'zustand';

interface DateState {
  today: dayjs.Dayjs;
  setToday: (date: dayjs.ConfigType) => void;
  selectedDate: {
    month: number;
    day: number;
    hour: number;
    minute: number;
  };
  setSelectedDate: (date: {
    month?: number;
    day?: number;
    hour?: number;
    minute?: number;
  }) => void;
}

const dateStore = create<DateState>((set) => ({
  today: dayjs(),
  setToday: (date) => set({ today: dayjs(date) }),
  selectedDate: {
    month: 4,
    day: 1,
    hour: 0,
    minute: 0,
  },
  setSelectedDate: (date) =>
    set((state) => ({
      selectedDate: { ...state.selectedDate, ...date },
    })),
}));

export { dateStore };
